export enum ScheduleDuration {
  DAY = "day",
  WEEK = "week",
  MONTH = "month",
}
